// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2zt_w","content":"LayoutSettings_content__2swQr"};